import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RenderContextComponent } from '../../../../../../../../../models/base/render-context-component';
import type { VariantsGroupedByBrand } from '../../../../../../../models/variants-grouped-by-brand';
import type { ShelfTalkerCardSize } from '../../../../../../../../../models/enum/dto/shelf-talker-card-size';
import type { GroupedByBrandShelfTalkerCardData } from '../../../../../../../../../models/shelf-talkers/grouped-by-brand-shelf-talker-card-data';

@Component({
  selector: 'app-fire-and-flower-shelf-talker-item',
  templateUrl: './fire-and-flower-shelf-talker-item.component.html',
  styleUrl: './fire-and-flower-shelf-talker-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireAndFlowerShelfTalkerItemComponent extends RenderContextComponent {
  @Input() shelfTalkerCardData: GroupedByBrandShelfTalkerCardData;
  @Input() variantsGroupedByBrand: VariantsGroupedByBrand;
  @Input() cardSize: ShelfTalkerCardSize;
  @Input() viewingInLiveView: boolean;

  setupViews() {}
  setupBindings() {}
}
